import "@/App.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Team from "./components/Team";
import Menu from "./components/Menu";
import LoyaltyCard from "./components/LoyaltyCard";
import Testimonials from "./components/Testimonials";
import Location from "./components/Location";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import WeeklyPromoPopup from "./components/WeeklyPromoPopup";

// URLs directas por sección, para compartir en redes/QR (ej. salkantay.es/carta)
const SECTION_ID_BY_PATH = {
  "/inicio": "inicio",
  "/nosotros": "nosotros",
  "/carta": "carta",
  "/opiniones": "testimonios",
  "/ubicacion": "ubicacion",
  "/contacto": "contacto",
};

function App() {
  const location = useLocation();

  useEffect(() => {
    const sectionId = SECTION_ID_BY_PATH[location.pathname];
    if (!sectionId) return;

    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className="App">
      {/* Grain Texture Overlay */}
      <div className="grain-overlay" />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        <Hero />
        <About />
        <Team />
        <Menu />
        <LoyaltyCard />
        <Testimonials />
        <Location />
        <Contact />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Button */}
      <WhatsAppButton />

      {/* Pop-up de la promoción de la semana */}
      <WeeklyPromoPopup />
    </div>
  );
}

export default App;
